// Copyright (c) 2020-2021 Visual Intelligence LP. All rights reserved.
//
import { Container } from 'inversify';

import Config from '@core/config';
import HTTPClient from '@core/http-client';
import BaseService from '@core/services/base';
import BaseStore from '@core/stores/base';
import AuthService from '@core/services/auth';
import AuthStore from '@core/stores/auth';
import EntitiesTemplatesStore from '@core/stores/entities-templates';

import * as sharedServices from '@shared/services';
import * as sharedStores from '@shared/stores';

const container = new Container();

const instances = [
  Config, 
  HTTPClient, 
  BaseService,
  BaseStore,
  AuthService,
  AuthStore,
  EntitiesTemplatesStore,
  ...Object.values(sharedServices),
  ...Object.values(sharedStores),
];

instances.forEach((instance: InstanceType<any>) => {
  container
    .bind(instance.diToken)
    .to(instance)
    .inSingletonScope();
});

export default container;